import React from 'react'
import values from 'mout/object/values'
import { SubjectNavLink } from './'
import sortByPropText from '../../../helpers/content/manageSets/sortByPropText'
import shortid from 'shortid'

export default function SubjectNavLinks({ subtests, uAid, query, activeSubtest, reportsRoute }) {
  const sortedSubtests = sortByPropText(values(subtests), 'displayName')
  return (
    <ul className='subject-nav-links'>
      {
        sortedSubtests.map(subtest =>
          <SubjectNavLink
            subtest={subtest}
            uAid={uAid}
            query={query}
            activeSubtest={activeSubtest}
            key={shortid.generate()}
            reportsRoute={reportsRoute}
          />
        )
      }
    </ul>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/SubjectNavLinks.js